







































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: false,
            default: ""
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        ariaLabelTooltip: {
            type: String,
            required: false,
            default: ""
        },
        inputTooltip: {
            type: Boolean,
            required: false,
            default: false
        },
        inputLabel: {
            type: String,
            required: true
        },
        inputDescription: {
            type: String,
            required: false,
            default: "",
        },
        inputPlaceholder: {
            type: String,
            required: false,
            default: ""
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: true
        },
        inputValue: {
            type: String,
            required: false,
            default: ""
        },
        inputLabelExtra: {
            type: String,
            required: false,
            default: ""
        },
        inputReadonly: {
            type: Boolean,
            required: false,
            default: false
        },
        gridLayout: {
            type: String,
            required: false,
            default: ""
        },
        specificId: {
            type: String,
            required: false,
            default: ""
        },
        inputRequired: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            uniqueId: (this.specificId != "") ? this.specificId : uuidv4() as string
        };
    },
    computed: {
        className: function(): string {
            let className = "input--text";
            if (this.errorMessage) {
                className += " input--error";
            }

            if (this.gridLayout !== "") {
                className += " " + this.gridLayout;
            }

            return className;
        }
    },
    methods: {
        input: function (value: string) {
            this.$emit("input", value);
        },
        blur: function(value: string) {
            this.$emit("blur", value);
        }
    }
});
